<template>
    <div class="border-t border-gray-200 mt-6">
        <envelope-list-item
            v-for="envelope in envelopes"
            :key="envelope.id"
            :envelope="envelope"
        />
    </div>
</template>

<script>
import EnvelopeListItem from './envelope-list-item.vue';

export default {
    components: {
        EnvelopeListItem,
    },

    props: {
        envelopes: {},
    },
}
</script>
